var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapeBottomRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 284,
    viewBox: "0 0 402 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.983 204.289C9.34557 185.272 13.0007 268.907 23.9592 304.05L434.338 310.851V98.8602C365.491 15.5965 292.281 105.602 271.179 172.352C245.949 229.315 158.863 217.137 108.983 204.289Z",
    fill: "#014641"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.702 186.758C-10.774 161.282 -5.87756 273.322 8.80281 320.401L558.558 329.512V45.523C466.328 -66.0193 377.2 59.9538 339.985 143.975C306.187 220.283 189.523 203.97 122.702 186.758Z",
    stroke: "#32AAA1",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeBottomRight);
export default __webpack_public_path__ + "static/media/Shape-BottomRight.6c6b04aa409fa783b993fb7452679e10.svg";
export { ForwardRef as ReactComponent };